import { StatusHistory } from "@inosio/payments-sdk";
import { Card, Divider, Grid, Modal, Typography, useMediaQuery } from "@mui/material";
import { format} from "date-fns";
import CancelIcon from "../../../icons/close.svg";

export interface ViewMaintenanceDetailsModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  statusHistory: StatusHistory[];
}
function ViewMaintenanceDetailsModal(props: ViewMaintenanceDetailsModalProps) {
  //------Styles-----//
  const matchesMobile = useMediaQuery("(max-width:600px)");
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    height: matchesMobile ? "100%" : "555px",
    pointerEvents: "auto",
    width: matchesMobile ? "100%" : "520px",
    borderRadius: matchesMobile ? "0px":"24px",
  };
  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      BackdropProps={{
        invisible: false,
      }}
      disableEscapeKeyDown
    >
      <Card sx={style}>
        <Grid container width="100%" height="100%">
          <Grid item xs={12} display="Flex" justifyContent="center">
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "18px",
                color: "#14142B",
              }}
            >
              {props?.title}
            </Typography>
          </Grid>
          <Grid item xs={12} display="Flex" justifyContent="center">
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "18px",
                color: "#14142B",
              }}
            >
              History
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              height: 400,
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: 7,
              },
              "&::-webkit-scrollbar-track": {
                boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                borderRadius: "24px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "darkgrey",
                borderRadius: "24px",
              },
            }}
          >
            {props?.statusHistory?.map((status, i, row) => {
              return (
                <Grid container key={i}>
                  <Grid item xs={12} display="Flex" justifyContent="center">
                    <Typography
                      sx={{
                        fontFamily: "Work Sans",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "#14142B",
                      }}
                    >
                      {status?.StatusDescription}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} display="Flex" justifyContent="center">
                    <Typography
                      sx={{
                        fontFamily: "Work Sans",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#14142B",
                      }}
                    >
                      {format(new Date(status?.StatusDate), "MM/dd/yyyy 'at' h:m a")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} display="Flex" justifyContent="center">
                    {i + 1 === row.length ? <></> : <Divider orientation="vertical" flexItem sx={{ height: "50px" }} />}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        {/* Close Icon */}
        <Grid item sx={{ position: "absolute", top: 18, right: 20 }}>
          <img
            src={CancelIcon}
            alt="close"
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.onClose();
            }}
          />
        </Grid>
      </Card>
    </Modal>
  );
}

export default ViewMaintenanceDetailsModal;
